export default {
    business: ['2B需求'], // 商务部
    market: ['其他需求'], // 市场部
    video: ['其他部门内容', '其他需求','尾板预约', '直播预告'], // 视频部
    om: ['其他需求'], // 产品运营部
    shop: ['2C需求'], // 果壳电商
    store: ['2C需求'], // 果壳商店
    zaih: ['2C需求'], // 在行
    eat: ['2C需求'], // 吃货
    beauty: ['2C需求'], // 果壳美丽
    knowledge: ['2C需求'], // 知识服务
    brand: ['2C需求'], // 自营品牌
    claw: ['2C需求'], // 递爪
    science: ['2G需求', '其他部门内容'], // 科普服务部
    lamp: ['其他部门内容', '其他需求'], // 放大灯 -> 科创部
    datamuse: ['其他部门内容', '其他需求'], // datamuse
    newmedia: ['其他部门内容'], // 电商新媒体 -> 电商内容
    marketing: ['2C需求'], // 营销部
    children: ['其他部门内容'], // 果壳儿童 -> 果壳童学馆
    coffee: ['豆选/妙壳/新项目'], // 豆选咖啡
    nuts: ['豆选/妙壳/新项目'], // 妙壳
    '4d0d276d-be11-432a-89e9-3eda34158e45': ['2C需求', '2C坑位'], // 2026年3月6日 吴暇，包含两个类型 https://taiga.iguokr.com/project/yan-fa-shi-yan-shi/us/236?milestone=599
    '3d4ac700-27a7-4ca3-8875-b45625cee4a7': ['2C需求', '2C坑位'], // 测试号
} as Config

interface Config {
    [type: string]: any
}
